import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef(null);

  const isActive = (path) => location.pathname === path;

  const toggleMenu = () => setIsMenuOpen((v) => !v);

  // Close on route change
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  // Close on ESC
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && setIsMenuOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  // Lock body scroll when menu open
  useEffect(() => {
    if (isMenuOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => (document.body.style.overflow = '');
  }, [isMenuOpen]);

  return (
    <nav className="navbar" data-testid="main-navbar">
      <div className="navbar-content">
        <Link to="/" className="navbar-brand" data-testid="navbar-logo">
          <div className="logo-placeholder">VK</div>
          <span>Professor Vasha Kaur</span>
        </Link>

        {/* Desktop nav */}
        <ul className="navbar-nav desktop-only" data-testid="navbar-menu-desktop">
          <li><Link to="/" className={isActive('/') ? 'active' : ''}>Home</Link></li>
          <li><Link to="/about" className={isActive('/about') ? 'active' : ''}>About</Link></li>
          <li><Link to="/services" className={isActive('/services') ? 'active' : ''}>Services</Link></li>
		            <li><Link to="/book-appointment" className={isActive('/book-appointment') ? 'active' : ''}>Book Appointment</Link></li>

          <li><Link to="https://www.vashakaur.com/blogs" className={({isActive}) => isActive ? 'text-indigo-600' : 'hover:text-slate-900'}>Blog</Link></li>

          <li><Link to="/patient-info" className={isActive('/patient-info') ? 'active' : ''}>Patient Info</Link></li>
          <li><Link to="/contact" className={isActive('/contact') ? 'active' : ''}>Contact</Link></li>
        </ul>

        {/* Mobile button */}
        <button
          className="mobile-menu-btn"
          onClick={toggleMenu}
          aria-label="Toggle mobile menu"
          aria-expanded={isMenuOpen}
          aria-controls="mobile-menu"
          data-testid="mobile-menu-toggle"
        >
          <span></span><span></span><span></span>
        </button>
      </div>

      {/* Mobile overlay + drawer */}
      <div
        className={`mobile-backdrop ${isMenuOpen ? 'show' : ''}`}
        onClick={() => setIsMenuOpen(false)}
      />
      <ul
        id="mobile-menu"
        ref={menuRef}
        className={`navbar-nav mobile-drawer ${isMenuOpen ? 'mobile-open' : ''}`}
        data-testid="navbar-menu"
        role="menu"
      >
        <li role="none">
          <Link to="/" role="menuitem" className={isActive('/') ? 'active' : ''}>Home</Link>
        </li>
        <li role="none">
          <Link to="/about" role="menuitem" className={isActive('/about') ? 'active' : ''}>About</Link>
        </li>
        <li role="none">
          <Link to="/services" role="menuitem" className={isActive('/services') ? 'active' : ''}>Services</Link>
        </li>
		
		  <li role="none">
          <Link to="/book-appointment" role="menuitem" className={isActive('/book-appointment') ? 'active' : ''}>Book Appointment</Link>
        </li>
		
		
        <li role="none">
          <Link to="/patient-info" role="menuitem" className={isActive('/patient-info') ? 'active' : ''}>Patient Info</Link>
        </li>
        <li role="none">
          <Link to="/contact" role="menuitem" className={isActive('/contact') ? 'active' : ''}>Contact</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
